export default {
  login: async (login_url, client_id, redirect_uri = window.location.origin) => {
    window.location.href = `${login_url}/?client_id=${client_id}&redirect_uri=${redirect_uri}`;
  },
  verify: async (path, id_token, client_id, redirect_uri = window.location.origin) => {
    return await fetch(path, {
      method: 'POST',
      body: JSON.stringify({ id_token, client_id, redirect_uri }),
    }).then((res) => {
      return {
        isAuth: !(res.status in notPermissionError),
        isSuccess: res.status === 200,
      };
    });
  },
  getNameFromToken: (token) =>{
    try{
      const base64Url = token.split('.')[1];                             
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); 
      const user_info = JSON.parse( decodeURIComponent(escape(atob(base64))));
      
      if(user_info['family_name'] === undefined || user_info['given_name'] === undefined)
        throw new Error()

      return `${user_info['family_name']} ${user_info['given_name']}`;
    } catch {
      return ""
    }
  }
};

const notPermissionError = ['401'];
